import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import authTimeout from './utils/authTimeout';
// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import dayjs from 'dayjs'
import permissionDirective from './directives/hasPermission' 

// 注册自定义指令
Vue.directive('hasPermission', permissionDirective);

// 注册全局时间格式化过滤器：将 ISO 格式（含 T）转为 "YYYY-MM-DD HH:mm:ss"
Vue.filter('formatTime', function(timeStr) {
  if (!timeStr) return '-';
  const isValid = dayjs(timeStr).isValid();
  return isValid ? dayjs(timeStr).format('YYYY-MM-DD HH:mm:ss') : '无效时间';
})

// 注册Element UI
Vue.use(ElementUI) 

Vue.config.productionTip = false

// 初始化超时控制
// authTimeout.init();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
